import React, { Component } from "react";
import Grid from "../../Utils/Grid";
import { reduxForm } from "redux-form";
import OrderSearchComponent from "../../Utils/OrderSearch/orderSearch";
import Title from "../../Utils/Headers/Title";
import { standardActions } from "../../Utils/Grid/StandardActions";

class List extends Component {
    componentDidMount() {
        console.log("SystemRoles List Mounted");
        this.props.listar();
    }

    render() {
        const { listar, data, loader, onSortChange, searchChange, eliminar } = this.props;

        const columns = [
            {
                dataField: "const_value",
                text: "ID",
                sort: true,
            },
            {
                dataField: "name",
                text: "Nombre",
                sort: true,
            },
            {
                dataField: "description",
                text: "Descripción",
                sort: true,
            },
            {
                dataField: 'id',
                text: 'Acciones',
                formatter: (cell, row) => standardActions({
                    ver: '/system-role',
                    editar: '/system-role',
                    eliminar
                })(cell, row)
            }
        ];

        return (
            <div className="py-4">
                <div className="row">
                    <div className="mb-4 col-lg-12">
                        <Title
                            showCreate={true}
                            title={"Roles del Sistema"}
                            linkToRedirect={"#/system-role/create"}
                            titleCreate={"Crear Rol"}
                            subtitle={"Listado de roles de sistema disponibles"}
                        />
                        <div className="mb-4 card card-small">
                            <OrderSearchComponent searchChange={searchChange} customClass='row mx-auto w-100 mt-2 justify-content-end' />
                            <div className="p-0 px-3 pt-3">
                                <Grid
                                    data={data}
                                    loading={loader}
                                    columns={columns}
                                    onPageChange={listar}
                                    onSortChange={onSortChange}
                                    noDataMessage={"Sin roles de sistema"}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default reduxForm({
    form: "ListSystemRoles",
})(List);
